import React from 'react';
import {scheduledDate, formatAmount} from '../../utils/banTypeClassifier';
import WarningMessage from '../WarningMessage';
import {buildUrlAndOpenWindow} from 'app/utilities/StringHelpers/StringHelpers';
import BanPaymentMethodRow from './BanPaymentMethodRow';
import Image from 'app/Components/Shared/Image/image';

const PaymentInProcessBanStatus = ({banData}) => {
  const {invoice, sent} = scheduledDate(banData);
  const getMessage = () => {
    return `החיוב בטיפול ולכן לא ניתן לשלם כעת במידה
    <br />
    והחיוב לא יעבור, נשלח עדכון ב-SMS`;
  };
  return (
    <div className='payment-in-process-ban-status'>
      <BanPaymentMethodRow banData={banData} />
      <div className='ban-status-card__section-divider' />
      <div className='payment-in-process-ban-status__balance'>
        <div className='payment-in-process-ban-status__balance-label'>{sent}</div>

        <div className=' payment-in-process-ban-status__balance-amount'>
          <div>
            <img src={require('../../images/dot.png')} alt='dot' />
          </div>
          <div className='balance-label'>
            <div>חוב בסך</div>
            <div className='amount'>₪{formatAmount(banData.pastDueAmt)}</div>
          </div>
        </div>

        <div className=' payment-in-process-ban-status__balance-amount'>
          <div>
            <img src={require('../../images/dot.png')} alt='dot' />
          </div>
          <div className='balance-label'>
            <div>{invoice} </div>
            <div className='payment-in-process-ban-status__balance-amount-value'>
              <span className='amount ml-2'>₪{formatAmount(banData.totalDueAmount)}</span>
              {banData.invoiceUrl && (
                <span className='invoice-link'>
                  <div type='button' className='link' onClick={() => buildUrlAndOpenWindow(banData.invoiceUrl)}>
                    לצפייה בחשבונית
                  </div>
                </span>
              )}
            </div>
          </div>
        </div>
      </div>

      <WarningMessage message={getMessage()} />
    </div>
  );
};

export default PaymentInProcessBanStatus;
